import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 retrieve_home_page_analytical_data: { status: "idle" },
};

export const retrieve_home_page_analytical_data_Slice = createSlice({
 name: "retrieve_home_page_analytical_data",
 initialState,
 reducers: {
  success_retrieve_home_page_analytical_data: (state, action) => {
   state.retrieve_home_page_analytical_data = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_home_page_analytical_data: (state, action) => {
   state.retrieve_home_page_analytical_data = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_home_page_analytical_data: (state) => {
   state.retrieve_home_page_analytical_data = { status: app_consts.IDLE };
  },
  loading_retrieve_home_page_analytical_data: (state) => {
   state.retrieve_home_page_analytical_data = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_home_page_analytical_data, fail_retrieve_home_page_analytical_data, reset_retrieve_home_page_analytical_data, loading_retrieve_home_page_analytical_data } = retrieve_home_page_analytical_data_Slice.actions;

export default retrieve_home_page_analytical_data_Slice.reducer;